import 'react-circular-progressbar/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import icon2 from '../../assets/images/backoffice/kyc6.png';

import { AnimatedDashboard } from '../../components';
import { useWindowWide } from '../../helpers/wideScreen';
import { AKASHA, DASHBOARD, TRADING } from '../../routes/routes';
import { H2, H3, P1, P2 } from '../../styles/FontStyles';
import { Button } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { Desktop, Mobile, TitleImage } from './KycStyled';
import { useAppSelector } from '../../app/hooks';

const KycFinish = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('kyc');
  const wide = useWindowWide(1000);
  const { isCanadaRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );

  const HandleToNextPage = () => {
    history.push(isCanadaRestrictedUser ? DASHBOARD : AKASHA);
  };

  return (
    <AnimatedDashboard key={'kyc-finish'}>
      <div
        style={{
          paddingTop: !wide ? '12vh' : '',
          textAlign: !wide ? 'center' : 'left'
        }}>
        <TitleImage>
          <img
            src={icon2}
            alt='icon'
            style={{ marginBottom: 40, width: 220 }}
          />
        </TitleImage>

        <Desktop>
          <H2 mb='12'>
            <b>{t('finish.title_part_1')}</b> {t('finish.title_part_2')}
          </H2>

          <P1
            mb='40'
            maxWidth='600px'
            maxWidthSM='1000px'
            color={colors.neutral500}>
            {t('finish.subtitle')}
          </P1>
        </Desktop>
        <Mobile>
          <H3 mb='8' center>
            {t('finish.title_part_1')}
          </H3>

          <P2 mb='32' center color={colors.neutral500}>
            {t('finish.subtitle')}
          </P2>
        </Mobile>

        <Desktop>
          <Button onClick={() => HandleToNextPage()} maxWidth='200px'>
            {t('finish.continue_btn')}
          </Button>
        </Desktop>
        <Mobile>
          <Button onClick={() => HandleToNextPage()}>
            {t('finish.continue_btn')}
          </Button>
        </Mobile>
      </div>
    </AnimatedDashboard>
  );
};

export default KycFinish;
